const axios = require("axios");

export default {
  state: {
    totalUnreadChats:0, 
    users: null,
    loggedInUserProfile: null,
    inbox: null,
    messages: null,
    lastMessage: null,
    chatId: null,
  },
  getters: {
    getTotalUnreadMessage(state)
    {
      return state.totalUnreadChats;
    },
    getChatUsers(state) {
      return state.users;
    },
    getloggedInUserProfile(state) {
      return state.loggedInUserProfile;
    },
    getInbox(state) {
      return state.inbox;
    },
    getMessages(state) {
      return state.messages;
    },
    getLastMessage(state) {
      return state.lastMessage;
    },
    getChatId(state) {
      return state.chatId;
    },
  },
  mutations: {
    setTotalUnreadMessage(state,response)
    {
      state.totalUnreadChats = response;
    },
    setUsers(state, response) {
      state.users = response;
    },
    setUserProfile(state, response) {
      state.loggedInUserProfile = response;
    },
    setInbox(state, response) {
      state.inbox = response;
    },
    setMessages(state, response) {
      state.messages = response;
    },
    setLastMessage(state, response) {
      state.lastMessage = response;
    },
    setChatId(state, response) {
      state.chatId = response;
    },
  },
  actions: {
    async getUserProfile({ commit }, userId) {
      await axios
        .get(
          `${
            process.env.VUE_APP_SERVERSIDE_URL
          }VeinsAPI/Users/GetUser?userId=${parseInt(userId)}`
        )
        .then(function(response) {
          commit("setUserProfile", response.data.userInfo);
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async getUsers({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Users/GetUsers`,
          payload
        )
        .then(function(response) {
          if (response.data.status) {
            commit("setUsers", response.data.data);
          }
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async getUserInbox({ commit }, payload) {
      await axios
        .post(`${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/GetInbox`, payload)
        .then(function(response) {
          if (response.data.status) {
            commit("setInbox", response.data.data);
          }
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async sendMessage({ commit }, payload) {
      // Create a new FormData object
      var formData = new FormData();

      // Add properties to the FormData object
      formData.append(
        "dummyComm[auditFlagVal]",
        payload.dummyComm.auditFlagVal
      );
      formData.append("chatId", payload.chatId);
      formData.append("chatType", payload.CHATTYPE);
      if (payload.CHATNAME !== null) {
        formData.append("chatName", payload.CHATNAME);
      }
      if (
        payload.adminId !== null ||
        payload.adminId !== undefined ||
        payload.adminId !== 0
      ) {
        formData.append("adminId", payload.adminId);
      } else {
        formData.append("adminId", 0);
      }

      if (payload.taggedUserId != null) {
        payload.taggedUserId.forEach(function(taggedUser, index) {
          formData.append(`taggedUserId[${index}].TaggedUserId`, taggedUser);
        });
      }

      // Add Participants to the FormData object
      if (payload.PARTICIPANTS != null) {
        payload.PARTICIPANTS.forEach(function(participant, index) {
          formData.append(`participants[${index}].USERID`, participant.USERID);
        });
      }

      if (payload.participants != null) {
        payload.participants.forEach(function(participant, index) {
          formData.append(`participants[${index}].USERID`, participant.userId);
        });
      }

      // Add Message properties to the FormData object
      formData.append("senderId", payload.senderId);
      formData.append("receiverId", payload.receiverId);
      formData.append("messageText", payload.messageText);
      formData.append("messageType", payload.messageType);

      // Add File to the FormData object
      formData.append("file", payload.file);

      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/SendMessage`,
          formData
        )
        .then(function(response) {
          if (response.data.status === true) {
            commit("setLastMessage", response.data.data);
            commit("setChatId", response.data.data.chat_Id);
            return response.data;
          }
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async markAsReadChat({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/MarkAsReadChat?userId=${payload.userId}&chatId=${payload.chatId}`
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async archiveChat({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/ArchiveChat?userId=${payload.userId}&chatId=${payload.chatId}`
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async leaveChat({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/LeaveChat`,
          payload
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async removeUser({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/RemoveUser`,
          payload
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async addParticipants({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/AddParticipants`,
          payload
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async getMessagesByChatId({ commit }, chatId) {
      await axios
        .get(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Chat/GetMessages?chatId=${chatId}`
        )
        .then(function(response) {
          if (response.data.status) {
            commit("setMessages", response.data.data);
          }
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async saveFirebaseToken({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_PRACTICESERVERSIDE_URL}/VNSPRAAPI/Practices/SaveToken`,
          payload
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async removeFirebaseToken({ commit }, payload) {
      await axios
        .post(
          `${process.env.VUE_APP_SERVERSIDE_URL}api/Users/RemoveFirebaseToken`,
          payload
        )
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
